// extracted by mini-css-extract-plugin
module.exports = {"WrapperForOCPTMobile":"OrderCompletionPageTemplateMobile_WrapperForOCPTMobile__13QDQ"};